function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextBox from './TextBox';
import { MailIcon } from '../../build';
import '../assets/inputFields.css';
const MailBoxField = props => /*#__PURE__*/React.createElement(TextBox, _extends({}, props, {
  key: props.name || +new Date(),
  InputProps: {
    startAdornment: /*#__PURE__*/React.createElement(MailIcon, null)
  }
}));
const MailBox = withStyles({
  root: {
    '& .MuiInputBase-root': {
      color: 'white',
      fontWeight: 500
    },
    '& svg': {
      margin: '10px'
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'white'
    },
    '& .MuiInput-colorSecondary.MuiInput-underline:after': {
      borderColor: 'white',
      borderBottomColor: 'white !important'
    }
  }
})(MailBoxField);
MailBoxField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number
};
export default MailBox;